import { Module } from "vuex-class-modules";
import { CollectionStore } from "../../../../../common/src/stores/CollectionStore";
import { ReportListItem } from "@gsx/common/src/types/http/admin/report";

@Module()
export class ReportCollectionStore extends CollectionStore<ReportListItem> {
    sort: keyof ReportListItem = "title";
}
